import { commitLocalUpdate, useRelayEnvironment } from 'react-relay';
import type RelayModernEnvironment from 'relay-runtime/lib/store/RelayModernEnvironment';

export const _useDeleteBoard = ({ environment }: { environment: RelayModernEnvironment }) => {
	const deleteBoard = (boardDataId: string) => {
		commitLocalUpdate(environment, (store) => {
			store.delete(boardDataId);
		});
	};

	return {
		deleteBoard,
	};
};

export const useDeleteBoard = () => {
	const environment = useRelayEnvironment();
	return _useDeleteBoard({ environment });
};
